export default "__VITE_ASSET__Dww221am__"